import React, { useEffect, useContext } from 'react';
import _ from 'lodash'
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Loader from 'modules/common/components/Loader';
import * as actions from '../actions';

import CmsContext from '../../../context/CmsContext';

function LogoutContainer({ history, logout }) {
  const cmsContext = useContext(CmsContext);
  const CMS_LOGO = cmsContext.findByType('LOGOS');
  const cmsLogo = _.get(CMS_LOGO, 'LOGO.cdnUrl');

  useEffect(() => {
    logout(() => {
      history.push('/');
    });
  }, []);
  return <Loader customLogo={cmsLogo} />;
}

LogoutContainer.propTypes = {
  logout: PropTypes.func.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = () => ({});

export default connect(mapStateToProps, actions)(LogoutContainer);
